import { authNotify, onAuthError, saveLocationForRedirect } from "../data/get/user";

export function shouldAbortFetchErrorHandling(response) {

    if (!response?.error?.status) throw ('shouldAbortFetchErrorHandling must have fetch response with status as an argument');

    switch (response.error.status) {
        case 401:
            saveLocationForRedirect();
            onAuthError();
            authNotify();
            return false;
    }
}